<template>
  <PrintPage :pageNumber="pageNumber" :pageCount="pageCount">
    <template v-slot:header>
      <PrintHeaderSSPSlim />
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>2 {{ $t('hak') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('hakLocationState') }}</div>
        <div>
          {{ locationStateLabel(project.salesReport && project.salesReport.salesHakLocationState) }}
        </div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.salesHakAttachments"
      fieldName="hakAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';

export default {
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: { type: Object, required: true },
    pageNumber: { type: Number, default: 2 },
    pageCount: { type: Number, default: 3 },
  },
  methods: {
    locationStateLabel(state) {
      return state ? this.$t(state) : '-';
    },
  },
};
</script>
